var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    ref: "section_content",
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    ref: "enquire_labs_target",
    attrs: {
      "id": "enquire_labs_target"
    }
  }), _vm._v(" "), _vm.visible ? _c('a', {
    staticClass: "skip-survey flex items-center mt-8",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.continueButtonAction.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "mr-4",
    attrs: {
      "src": require("assets/images/arrow-right.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("SKIP")])]) : _vm._e(), _vm._v(" "), _vm.visible ? _c('disclosure-footer') : _vm._e()], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };